(function() {
    'use strict';

    angular
        .module('jcsfApp')
        .directive('waitSpinner', waitSpinner);

    waitSpinner.$inject = ['messaging', 'events'];
    
    function waitSpinner(messaging, events) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: '/app/directives/waitSpinner/waitSpinner.html',
            link: function (scope, element, attrs, fn) {
                element.hide();

                var startRequestHandler = function () {
                    // got the request start notification, show the element
                    element.show();
                };

                var endRequestHandler = function () {
                    // got the request start notification, show the element
                    element.hide();
                };

                scope.startHandle = messaging.subscribe(events.message._SERVER_REQUEST_STARTED_, startRequestHandler);
                scope.endHandle = messaging.subscribe(events.message._SERVER_REQUEST_ENDED_, endRequestHandler);

                scope.$on('$destroy', function () {
                    messaging.unsubscribe(scope.startHandle);
                    messaging.unsubscribe(scope.endHandle);
                });
            }
        };
    }

})();